/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import endpointConfig from "../config/endpoints.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { IMPORT_HOLDERS } from "../graphql";
import { VApplication } from "../../../application";
import { HoldersListPageService } from "../../HoldersListPageService";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const getHoldersListService = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.HoldersListPageService") as HoldersListPageService;
};

const isTruthy = (value: any) => {
  if (value === true) return true;
  if (value === false) return false;
  if (value === undefined || value === null) return false;
  const str = String(value).trim().toLowerCase();
  return ["true", "1", "yes", "y", "on"].includes(str);
};

export interface IGroupServiceMethods extends IPluginMethodMap {
  importHolders(args: any): any;
}

export class GroupService implements IAgentPlugin {
  readonly methods: IGroupServiceMethods;

  constructor() {
    this.methods = {
      importHolders: this.importHolders.bind(this),
    };
  }

  async importHolders(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const allRows = Array.isArray(args?.validData) ? args.validData : [];
        if (allRows.length === 0) {
          return { message: "no holders provided" };
        }
        const res = await client.mutate({
          mutation: IMPORT_HOLDERS,
          variables: {
            users: allRows,
            holders: allRows,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.importUsers) {
          return {
            ...res?.data?.importUsers,
          };
        }
        if (res?.data?.importHolders) {
          return {
            ...res?.data?.importHolders,
          };
        }
      }
    } catch (err: any) {
      return err;
    }
    // try {
    //   // const res = await axios.post(endpointConfig?.createGroup, {
    //   //   data: args?.validData,
    //   // });
    //   // console.log("created group =>", res?.data);
    //   // return res?.data;
    //   return true;
    // } catch (err: any) {
    //   console.log("Error in create group", err?.message);
    // }
  }
}
